/**
 * This file is a component for E2 UI Customization
 */
 import React, {useState, useEffect} from 'react';
 import { Grid, Tooltip, FormControlLabel, Checkbox} from '@material-ui/core';
 import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';

 export default function EmailForward(props)
 {
     const [forward, setForward] = useState(false);
 
     /** Set live chat to value being passed through props */
     useEffect(() => {
         setForward(props.value);
     },[props.value]);
     
     /**Handle changes to live chat checkbox */
     const handleForward = () => {
         setForward(!forward);
         props.onChange(!forward);
     }
 
     return(
         <div>
             <Grid container direction="row" alignItems="center">
                 <Grid item>
                     <FormControlLabel
                     control={
                         <Checkbox
                         checked={forward}
                         onChange={handleForward}
                         name="forward"
                         color="primary"
                         />
                     }
                     label="Forward"
                     />
                 </Grid>
                 <Grid item>
                     <Tooltip title="Toggles the button that allows the agent to forward the email.">
                         <ArrowForwardOutlinedIcon color="primary"/>
                     </Tooltip>
                 </Grid>
             </Grid>
         </div>
     );
 }
 
 